import { getTestId } from '@airtel/air-design-system';
var additionalBenefits = [{
  benefitUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
  benefitText: 'OTT'
}, {
  benefitUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
  benefitText: 'OTT'
}, {
  benefitUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
  benefitText: 'OTT'
}, {
  benefitUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
  benefitText: 'OTT'
}, {
  benefitUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
  benefitText: 'OTT'
}, {
  benefitUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
  benefitText: 'OTT'
}];
export var defaultProps = Object.assign(Object.assign({
  widgetGenericRendererKey: 'AirOrderSummaryCardWidget',
  showItemSeparator: false,
  isHorizontalScroll: false,
  isGridView: true,
  pageSize: 2,
  title: '',
  infoTagProps: null,
  calloutWidgetProps: {
    title: '',
    description: 'Removed services will be billed separately.',
    iconName: 'AlertMediumButtonIcon',
    state: 'warning'
  },
  data: Array.from({
    length: 10
  }, (_, index) => ({
    removeCardBorderRadius: true,
    title: 'Postpaid • 9108266546',
    onItemImpression: {
      id: index
    },
    subTitle: '2GB/day • 28 days validity',
    priceDetails: {
      price: '₹599.00',
      oldPrice: '₹99.00',
      isOldPriceStriked: false
    },
    additionalBenefits: additionalBenefits,
    imageUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
    tertiaryActionButtonText: 'view details',
    infoTagText: 'text label',
    incrementalStepperProps: {
      size: 'sm',
      value: '1'
    },
    showAvatar: true,
    iconProps: {
      iconName: 'HomeIcon',
      variant: 'icon'
    },
    noBorderRadius: false
  })),
  showCard: false,
  showShadow: false,
  showCallout: false
}, getTestId('DynamicScrollListWidgetContainer')), {
  onUserAction: console.log
});